import React, { useState } from "react";
import CloseIcon from "../../Close.svg";
import Offers from "../../offers.svg";
import "../../App.css";

const CouponModel = ({ data, close, updateData }) => {
  const updateCoupon = (data) => {
    // console.log(data,"data")
    updateData(data);
    close();
  };

const OfferCouponComponent = ({ availableCoupons }) => {
  const [firstCoupon, setfirstCoupon] = useState(availableCoupons);

  return (
    <div
      className="coupon-box"
      onClick={() => updateCoupon(firstCoupon)}
    >
      <div className="coupon-top">
        <img src={Offers} alt="Offer Icon" className="offer-icon" />
        <div className="coupon-info">
          <div className="coupon-code">
            {availableCoupons?.code} - Flat {availableCoupons?.value}% off
          </div>
          <div className="coupon-description">
            {availableCoupons?.description}
          </div>
        </div>
      </div>
      <div className="coupon-apply">
        <span>Tap to Apply</span>
      </div>
    </div>
  );
};

  return (
    <div className="rn-modal-overlay" onClick={close}>
      <div
        className="rn-modal-sheet"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="rn-modal-header">
          <h4 className="rn-modal-title">Select Coupon</h4>
          <button className="rn-close-button" onClick={close}>
            <img src={CloseIcon} alt="Close" />
          </button>
        </div>
        <div className="rn-modal-content">
          {data.length > 0 ? (
                      // console.log(data,"data")

            data.map((item) => (
              <OfferCouponComponent
                key={item.id}
                availableCoupons={item}
              />
            ))
          ) : (
            <p className="rn-no-coupons">No coupons available</p>
          )
          }
        </div>
      </div>
    </div>
  );
};

export default CouponModel;
